import type { Session } from "@supabase/supabase-js"
import { useQuery } from "@tanstack/react-query"

import { useStableFunction } from "@repo/ui/hooks/use-stable-function"
import { useSupabase } from "./use-supabase"

export const queryKey = ["auth", "session"]

export type UseSessionProps = {
  initialData?: Session | null
}

export function useSession({ initialData }: UseSessionProps = {}) {
  const supabase = useSupabase()

  const queryFn = useStableFunction(async () => {
    const { data, error } = await supabase.auth.getSession()

    if (error) {
      return null
    }

    if (data?.session) {
      return data.session
    }

    return Promise.reject(new Error("Unexpected result format"))
  })

  return useQuery({
    queryFn,
    queryKey,
    initialData,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    staleTime: 1000 * 60 * 5, // 5 minutes
  })
}
